import { Trans } from "@lingui/react";
import * as React from 'react';
import { Button } from '~ui/components/buttons/Button/Button';
import { Text } from '~ui/components/typography/Text/Text';
import { useLayoutIsXS } from '../../Responsive/client';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Button that opens the guide of the app.
 */
export var GuideButton = function GuideButton(_ref) {
  var openGuide = _ref.openGuide;
  var isMobile = useLayoutIsXS();
  return /*#__PURE__*/_jsx(Button, {
    shadow: "none",
    padding: "medium",
    variant: "ghost",
    width: "fit-content",
    onClick: openGuide,
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(Text, {
      fontSize: isMobile ? "m16" : "l20",
      lineHeight: 1.2,
      textDecoration: "underline",
      children: /*#__PURE__*/_jsx(Trans, {
        id: "Z7K0px"
      })
    })
  });
};